import React from 'react';
import * as styles from './styles.module.scss';

import TransactionInfoCard from '@/components/Elements/TransactionInfoCard';

const Transactions = ({ data }) => (
  <div className={styles.trans}>
    <div className={styles.trans_bg}></div>

    <TransactionInfoCard
      className={styles.trans_card}
      counter={data.card.counter}
      desc={data.card.desc}
    />
  </div>
);

export default Transactions;
